import { Choice } from './Choice'
import { DateAnswer } from './DateAnswer'
import { DocumentAnswer } from './DocumentAnswer'
import { MonthAnswer } from './MonthAnswer'
import { NumberAnswer } from './NumberAnswer'
import { TextAnswer } from './TextAnswer'
import { YesNo } from './YesNo'
import type { AnswerProps } from './types'

// Answer is the one place that knows every question type of §3.5 of
// docs/plan/survey.md. The switch is exhaustive on the generated union, so a
// type added to the specification fails the build here until it has a component
// — which is the third of the three places the plan says a new type touches.
export function Answer(props: AnswerProps) {
  switch (props.question.type) {
    case 'single_choice':
    case 'country':
      return <Choice {...props} />
    case 'multi_choice':
    case 'countries':
      return <Choice {...props} multiple />
    case 'yes_no':
      return <YesNo {...props} />
    case 'date':
      return <DateAnswer {...props} />
    case 'month':
      return <MonthAnswer {...props} />
    case 'year':
    case 'number':
      return <NumberAnswer {...props} />
    case 'text':
      return <TextAnswer {...props} />
    case 'document':
      return <DocumentAnswer {...props} />
  }
}

export { isAnswered } from './types'
export type { AnswerProps, AnswerValue } from './types'
